import * as t from "io-ts";
import { FontV } from "@/types/fonts";

// Custom font types
const FontFileV = t.type({
  fileName: t.string,
  fileUrl: t.string,
  format: t.union([t.literal("woff"), t.literal("woff2")])
});

const FontFaceV = t.type({
  id: t.string,
  files: t.array(FontFileV),
  weight: t.number,
  style: t.union([t.literal("normal"), t.literal("italic")])
});

export const CustomFontFamilyV = t.type({
  id: t.string,
  family: t.string,
  cssUrl: t.string,
  hasExternalCssUrl: t.boolean,
  cssName: t.string,
  fallbackString: t.union([t.string, t.undefined]),
  faces: t.array(FontFaceV)
});

export type FontFile = t.TypeOf<typeof FontFileV>;
export type CustomFontFamily = t.TypeOf<typeof CustomFontFamilyV>;
export type FontFace = t.TypeOf<typeof FontFaceV>;

// Fetch responses types
export const FontFamiliesResponseV = t.array(
  t.type({
    fontId: t.string,
    cssUrl: t.string,
    fontRegistrationData: FontV
  })
);
export const FontFileResponseV = t.type({
  fileUrl: t.string,
  fileName: t.string
});

export type FontFamiliesResponse = t.TypeOf<typeof FontFamiliesResponseV>;
export type FontFileResponse = t.TypeOf<typeof FontFileResponseV>;
